/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { API } from '../api/api'
import { fetch } from '../api/httpClient'
import { COURSE_STATUS, DATEFORMAT } from '../helpers/constants'
import { formatDate, get, isEmpty, isNullOrEmpty } from '../helpers/utils'
import ActionTypes from './actionTypes'

export const parentAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.PARENTS,
    data,
  })
const checkForTypes = (key, value) => {
  if (value === '1') {
    return true
  } else if (value === '0') {
    return false
  } else {
    return value
  }
}

export const fetchChildrenListV1 =
  (pageDetails = {}, successCallback, failureCallback) =>
  async (dispatch) => {
    try {
      let url = `${API.CORE.CHILDREN_LIST}`
      if (pageDetails.q) {
        url += `?q=${pageDetails.q.trim()}`
      }
      const { data } = await fetch(url)
      data.forEach((childrenItem) => modifyUserItem(childrenItem))
      dispatch(
        parentAction({
          children: data || [],
          id: data[0]?.urn,
        })
      )

      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchEnrollmentsWithourProgress =
  (userUrn, successCallback, failureCallback) => async () => {
    try {
      if (!userUrn) {
        return
      }
      const url = `${API.CORE.ENROLLMENTPROGRAMS}?userUrn=${userUrn}`
      const { data } = await fetch(url)
      get(data, 'content', []).forEach((item) => modifyEnrollments(item))
      get(data, 'content', []).forEach((item) => {
        item.currentCourse = item?.enr_enrollment_course?.filter(
          (course) =>
            course?.enc_status === COURSE_STATUS.IN_PROGRESS ||
            course?.enc_status === COURSE_STATUS.PENDING
        )
        item.completedCourse = item?.enr_enrollment_course?.filter(
          (course) =>
            course?.enc_status === COURSE_STATUS.PASSED ||
            course?.enc_status === COURSE_STATUS.FAILED ||
            course?.enc_status === COURSE_STATUS.PASSED_WITHOUT_GRADE ||
            course?.enc_status === COURSE_STATUS.WITHDRAWN ||
            course?.enc_status === COURSE_STATUS.IN_COMPLETE
        )
        item.upComingCourse = item?.enr_enrollment_course?.filter(
          (course) => course?.enc_status === COURSE_STATUS.UPCOMING
        )
        item.pgm_meta_data = item.program_meta.reduce((value, currentItem) => {
          value[currentItem.md_meta_key] = checkForTypes(
            currentItem.md_meta_key,
            currentItem.md_meta_value
          )
          return value
        }, {})
      })
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchEnrollmentsWithProgress =
  (userUrn, successCallback, failureCallback) => async () => {
    try {
      if (!userUrn) {
        return
      }
      const url = `${API.CORE.ENROLLMENTS_WITH_PROGRESS}?userUrn=${userUrn}`
      const { data } = await fetch(url)
      get(data, 'content', []).forEach((item) => modifyEnrollments(item))
      get(data, 'content', []).forEach((item) => {
        item.currentCourse = item?.enr_enrollment_course?.filter(
          (course) =>
            course?.enc_status === COURSE_STATUS.IN_PROGRESS ||
            course?.enc_status === COURSE_STATUS.PENDING
        )
        item.completedCourse = item?.enr_enrollment_course?.filter(
          (course) =>
            course?.enc_status === COURSE_STATUS.PASSED ||
            course?.enc_status === COURSE_STATUS.FAILED ||
            course?.enc_status === COURSE_STATUS.PASSED_WITHOUT_GRADE ||
            course?.enc_status === COURSE_STATUS.WITHDRAWN ||
            course?.enc_status === COURSE_STATUS.IN_COMPLETE
        )
        item.upComingCourse = item?.enr_enrollment_course?.filter(
          (course) => course?.enc_status === COURSE_STATUS.UPCOMING
        )
        item.pgm_meta_data = item.program_meta.reduce((value, currentItem) => {
          value[currentItem.md_meta_key] = checkForTypes(
            currentItem.md_meta_key,
            currentItem.md_meta_value
          )
          return value
        }, {})
      })
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

const modifyUserItem = function (data) {
  if (isEmpty(data)) {
    return
  }
  data.dobLabel = !isNullOrEmpty(data?.dob) ? formatDate(data?.dob, DATEFORMAT) : ''
  data.birthDate = !isNullOrEmpty(data.birth_date) ? formatDate(data?.birth_date, DATEFORMAT) : ''
}

const modifyEnrollments = function (data) {
  if (isEmpty(data)) {
    return
  }
  const termCompletedCr = data?.enr_enrollment_course?.length
    ? data.enr_enrollment_course
        ?.filter(
          (values) =>
            (values.enc_status === 'passed' || values.enc_status === 'passed_without_grade') &&
            data.enr_current_grade === values.enc_grade_level
        )
        .reduce((acc, course) => acc + Number(course.enc_credits), 0)
    : 0
  const termAssignedCr = data?.enr_enrollment_course?.length
    ? data.enr_enrollment_course
        ?.filter(
          (values) =>
            (values.enc_state === 'assign' || values.enc_state === 'plan') &&
            values.enc_status !== 'in_review' &&
            values.enc_status !== 'in_complete' &&
            values.enc_status !== 'withdrawn' &&
            data.enr_current_grade === values.enc_grade_level
        )
        .reduce((acc, course) => acc + Number(course.enc_credits), 0)
    : 0
  const courseCompletedCr = data?.enr_enrollment_course?.length
    ? data.enr_enrollment_course
        ?.filter(
          (values) => values.enc_status === 'passed' || values.enc_status === 'passed_without_grade'
        )
        .reduce((acc, course) => acc + Number(course.enc_credits), 0)
    : 0
  const courseAssignedCr = data?.enr_enrollment_course?.length
    ? data.enr_enrollment_course
        ?.filter(
          (values) =>
            (values.enc_state === 'assign' || values.enc_state === 'plan') &&
            values.enc_status !== 'in_review' &&
            values.enc_status !== 'in_complete' &&
            values.enc_status !== 'withdrawn'
        )
        .reduce((acc, course) => acc + Number(course.enc_credits), 0)
    : 0
  data.termCompletedCourses = termCompletedCr
  data.termAssignedCourses = termAssignedCr
  data.courseCompletedCourses = courseCompletedCr
  data.courseAssignedCourses = courseAssignedCr
  data.enr_term_progress = Number(data.enr_term_progress)
  data.enr_enrolled_on = formatDate(data?.enr_enrolled_on, DATEFORMAT)
  data.expiry_date = formatDate(data?.expiry_date, DATEFORMAT)
  data.enr_end_date = formatDate(data.enr_end_date, DATEFORMAT)
  data.lastLoginTimeLabel = formatDate(data?.enr_last_login_time, DATEFORMAT)
  data.postGradResponse = []

  if (!isNullOrEmpty(data?.enr_active_invoice)) {
    data.enr_active_invoice.inv_billing_next_date = formatDate(
      data?.enr_active_invoice?.inv_billing_next_date,
      DATEFORMAT
    )
  }
}
